import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    location: ''
  });
  const purchases = [{
    name: 'Carlos M.',
    location: 'Buenos Aires, Argentina'
  }, {
    name: 'Diego R.',
    location: 'Madrid, España'
  }, {
    name: 'Martín L.',
    location: 'Santiago, Chile'
  }, {
    name: 'Roberto S.',
    location: 'Lima, Perú'
  }, {
    name: 'Andrés F.',
    location: 'Montevideo, Uruguay'
  }, {
    name: 'Pablo G.',
    location: 'Bogotá, Colombia'
  }, {
    name: 'Fernando T.',
    location: 'Ciudad de México, México'
  }, {
    name: 'Luis P.',
    location: 'Barcelona, España'
  }];
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const interval = setInterval(showPopup, 18000);
    const initialTimeout = setTimeout(showPopup, 5000);
    return () => {
      clearInterval(interval);
      clearTimeout(initialTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-120">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 bg-white text-dark rounded-lg shadow-2xl p-4 max-w-sm" data-id="element-121">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" data-id="element-122">
            <XIcon className="w-4 h-4" data-id="element-123" />
          </button>

          <div className="flex items-start gap-3" data-id="element-124">
            <img src="https://cdn.magicpatterns.com/uploads/heLoZZWJL3TJgHxcNkBzoG/Combinacion_completa_para_entrenadores_de_padel.png" alt="Megapack Pádel Listo" className="w-12 h-12 object-cover rounded flex-shrink-0" data-id="element-125" />
            <div data-id="element-126">
              <p className="font-bold text-sm mb-1" data-id="element-127">
                {currentPurchase.name} de {currentPurchase.location}
              </p>
              <p className="text-xs text-gray-600" data-id="element-128">
                acaba de comprar este producto.
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}